<template lang="pug">
  el-button(
    type="info"
    icon="el-icon-refresh"
    :loading="loading"
    @click="resetForm"
  ) 重置
</template>

<script>
export default {
  name: 'ResetButton',
  props: {
    remoteMethod: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async resetForm() {
      this.$parent.$parent.resetFields();
      this.loading = true;
      await this.remoteMethod();
      this.loading = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/resetButton/index.vue?b5d93d8a